import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import IntlService from 'ember-intl/services/intl';

export interface IOrderCycleSubmit {
  orderCycle?: number;
}

interface IArgs {
  orderCycle?: number;
  disabled: boolean;
  error?: string[] | string;
  onSubmit?: (value: IOrderCycleSubmit) => void;
}

export default class OrderCycleEditor extends Component<IArgs> {
  // Services
  // ~~~~~

  @service declare intl: IntlService;

  // Properties
  // ~~~~~

  @tracked temp: IOrderCycleSubmit = { orderCycle: this.args.orderCycle ?? 1 };

  // Lifecycle Hooks
  // ~~~~~

  // Actions
  // ~~~~~

  @action
  onOrderCycleChange(value?: string) {
    this.temp = {
      ...this.temp,
      orderCycle: (isPresent(value) ? parseInt(value as string, undefined) : undefined)
    };
    return this.onSubmit();
  }

  @action
  onSubmit() {
    return this.args.onSubmit?.(this.getDataToSubmit());
  }

  // Helper Functions
  // ~~~~~

  getDataToSubmit() {
    return { ...this.temp };
  }
}
